module.exports = __webpack_public_path__ + "static/media/girl-on-computer.8b467c95.svg";